import styled, {css} from "styled-components";
import {GAMEPLAY_PC_HEADER_BAR_GAMEMODE_LABEL_WIDTH} from "../css-consts";

export const GamePlayPcHeaderBarDemoLabelDefaultBox = styled.div<{isInRealMode: boolean}>`
    display: flex;
    flex-direction: row;
    width: ${GAMEPLAY_PC_HEADER_BAR_GAMEMODE_LABEL_WIDTH};
    justify-content: flex-start;
    ${
    props => props.isInRealMode
        ? css`
                        ${({theme}) => theme.font.presets.regular};
                        cursor: pointer;
                  `
        : css`
                        color: ${props => props.theme.colors.backgroundDark};
                        ${({theme}) => theme.font.presets.bold};
                  `
}
`